import { isObject, isString, values, flatten } from 'lodash';
import { captureException } from '@sentry/browser';
import i18n from '../i18n';

// eslint-disable-next-line import/prefer-default-export
export function parseResponseError(err) {
  if (err.response) {
    if (isObject(err.response.data.error) && isObject(err.response.data.error.errors)) {
      return flatten(values(err.response.data.error.errors)).join('<br />');
    } else if (isString(err.response.data.error)) {
      return err.response.data.error;
    }

    return i18n.t(`errors.error${err.response.status}`);
  } else if (err.request) {
    return i18n.t('errors.error500');
  }

  if (process.env.NODE_ENV === 'production') captureException(err);
  throw err;
}



// WEBPACK FOOTER //
// ./src/helpers/errors.js